module.exports = __webpack_public_path__ + "img/complete-secondary.d802eade.svg";